/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Status_Awaiting_ProcessingInputs */



/**
* | output |
* | --- |
* | "Awaiting Processing" |
*
* @param {Embed_Captions_Status_Awaiting_ProcessingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_status_awaiting_processing = /** @type {((inputs?: Embed_Captions_Status_Awaiting_ProcessingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Status_Awaiting_ProcessingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En attente de traitement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bearbeitung ausstehend")
	if (locale === "it") return /** @type {LocalizedString} */ ("In attesa di elaborazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ожидается обработка")
	if (locale === "es") return /** @type {LocalizedString} */ ("En espera de procesamiento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("等待处理")
	if (locale === "ja") return /** @type {LocalizedString} */ ("処理待ち")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोसेसिंग का इंतजार है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aguardando processamento")
	return /** @type {LocalizedString} */ ("Awaiting Processing")
});